<div ngbDropdown class='d-inline-block profile-dropdown-container'
     #profileDropdown='ngbDropdown'
     [placement]="['bottom-end']"
     [autoClose]="isHoverDropdown ? false : 'outside'"
     (mouseenter)='onMouseEnter($event)'
     (mouseleave)='onMouseLeave($event)'
>

  <a class='nav-link nav-menu' ngbDropdownToggle>
    <app-avatar
      [photoSrc]='photoSrc'
      [levelSrc]='levelSrc'>
    </app-avatar>
  </a>

  <div ngbDropdownMenu 
       class="dropdown-menu profile-dropdown-menu"
       (mouseenter)='onDropdownMouseEnter($event)'
       (mouseleave)='onDropdownMouseLeave($event)'>
    <a class='dropdown-item' (click)='onMyProfileSelected()'>
      My profile
    </a>
    <a *ngIf='canShowSettings'
       class='dropdown-item' (click)='onSettingsSelected()'>
      Settings
    </a>
    <a *ngIf='canShowNotifications'
       class='dropdown-item' (click)='onNotificationsSelected()'>
      Notifications
    </a>
    <a *ngIf='canShowPreferences'
       class='dropdown-item' (click)='onPreferencesSelected()'>
      Preferences
    </a>
    <a *ngIf='canShowTutorials'
       class='dropdown-item' (click)='onTutorialsSelected()'>
      Tutorials
    </a>
    <a *ngIf='canShowBookmarks'
       class='dropdown-item' (click)='onBookmarksSelected()'>
      Bookmarks
    </a>
    <a *ngIf='canShowCms'
       class='dropdown-item' (click)='onCmsSelected()'>
      Admin (Settings)
    </a>
    <a *ngIf='canShowInsights'
       class='dropdown-item' (click)='onInsightsSelected()'>
      EAP Dashboard
    </a>
    <a class='dropdown-item' (click)='onLogout()'>
      Logout
    </a>
  </div>
</div>
